import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api/axios";
import '../../css/login/login.css';

function Login() {

    const navigate = useNavigate();

    const [loginId, setLoginId] = useState("");
    const [loginPw, setLoginPw] = useState("");

    const login = () => {

        api.post("/user/login", {

            loginId,
            loginPw

        }).then((res) => {

            if (res.data.success) {
                
                localStorage.setItem(
                    "accessToken",
                    res.data.data.token
                );

                localStorage.setItem(
                    "userNo",
                    res.data.data.userNo
                );

                navigate("/dashboard");

            } else {

                alert(res.data.message);

            }

        });

    };

    return (

<div className="login-container">
  <div className="login-card">
    <div className="login-header">
      <h2>GooseDuck Trading</h2>
      <div className="login-subtitle">자동매매 시스템</div>
    </div>

    <input
      type="text"
      className="login-input"
      placeholder="아이디"
      value={loginId}
      onChange={(e) => setLoginId(e.target.value)}
    />

    <input
      type="password"
      className="login-input password"
      placeholder="비밀번호"
      value={loginPw}
      onChange={(e) => setLoginPw(e.target.value)}
    />

    <button className="login-button" onClick={login}>
      로그인
    </button>

    <div className="login-footer">
      <Link to="/join" className="login-link">
        회원가입
      </Link>
    </div>
  </div>
</div>

    );

}

export default Login;